const EditIcon = ({
  size = 12,
  color = "#3C2212",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M6.80892 2.18788L9.81212 5.19108L3.28954 11.7137L0.614813 11.9952C0.262875 12.0421 -0.042138 11.7371 0.00478704 11.3852L0.286337 8.71046L6.80892 2.18788ZM11.6657 1.74209C12.1114 2.16442 12.1114 2.89176 11.6657 3.33754L10.3518 4.65144L7.34856 1.64824L8.66246 0.334341C9.10824 -0.111447 9.83558 -0.111447 10.2579 0.334341L11.6657 1.74209Z"
        fill={color}
      />
    </svg>
  );
};

export default EditIcon;
